<div class="form">
  <h4 class="secondary-header"> Datos del vivero</h4>
  <div>
    <mat-form-field>
      <input matInput placeholder="Nombre:" [formControl]="nombre" required>
      <mat-error *ngIf="nombre.invalid">
        Debe ingresar nombre del vivero
      </mat-error>
    </mat-form-field>
  </div>
  <div>
    <h4 class="secondary-header"> Domicilio</h4>
  </div>
  <div class="row">
    <rpe-direcciones-geograficas-form [formInput]="direccionGeograficaInput"
      (formStatusChanges)="direccionGeograficaStatusChange($event)"
      (formValueChanges)="direccionGeograficaChange($event)" [withCountryOption]="false">
    </rpe-direcciones-geograficas-form>
  </div>
  <div class="row">
    <div>
      <h4 class="secondary-header"> Contacto del vivero</h4>
    </div>
    <rpe-datos-contacto-form [formInput]="datosContactoFormInput"
      (formStatusChanges)="datosContactoStatusChange($event)"
      (formValueChanges)="datosContactoChange($event)"></rpe-datos-contacto-form>
  </div>
  <div class="especies">
    <section class="example-section">
      <h4 class="secondary-header">Seleccionar los grupos de especies *</h4>
      <ng-container>
        <ul>
          <li *ngFor="let grupoEspecie of gruposEspecies">
            <mat-checkbox [checked]="isChecked(grupoEspecie)" (change)="onGruposEspeciesChange($event, grupoEspecie)">
              {{grupoEspecie.nombre}}
            </mat-checkbox>
          </li>
        </ul>
      </ng-container>
    </section>
  </div>
</div>